export const commonTH = {
  academic_year: "ปีการศึกษา",
  grade:'ระดับชั้น',
  add: "เพิ่ม",
  announcement_date: "วันที่ประกาศ",
  back: "ย้อนกลับ",
  cancel: "ยกเลิก",
  candidate_amount: "จำนวนผู้สมัคร",
  confirm: "ยืนยัน",
  create_at: "สร้างวันที่",
  create_date: "วันที่สร้าง",
  curriculum: "แผนการเรียน",
  currency: {
    baht: "บาท"
  },
  data_not_found: "ไม่พบข้อมูล",
  date: "วันที่",
  document: "เอกสาร",
  documents: "เอกสาร",
  grade_level: "ระดับชั้น",
  last_edited: "แก้ไขล่าสุด",
  pagination: {
    of: "จาก",
    row_per_page: "แถวต่อหน้า"
  },
  required_amount: "จำนวนที่เปิดรับ",
  search: "ค้นหา",
  status: "สถานะ",
  sidebar: {
    application_form: "รับสมัครนักเรียน",
    set_up_application_form: "ตั้งค่าการรับสมัคร",
    list_of_applicants: "รายชื่อผู้สมัคร",
    list_of_qualified_applicants: "รายชื่อผู้ผ่านการคัดเลือก",
  },
  time: "เวลา",
  top_menu: {
    other_system: "ระบบอื่นๆ",
    schoolbus_system: "รถรับ - ส่งนักเรียน",
    application_form: "รับสมัครนักเรียน",
    tuition_payment: "ชำระค่าเทอม",
  },
  logout: "ออกจากระบบ",
  id_card_number: "เลขบัตรประชาชน",
  full_name: "ชื่อ - นามสกุล",
  type: "ประเภท",
  suggestion: "คำแนะนำ",
  previous: "ก่อนหน้า",
  next: "ถัดไป",
  page: "หน้า",
  close: "ปิด",
  person: "คน",
  applicantInfo: "ข้อมูลผู้สมัคร",
  edit:{
    basic: "ข้อมูลนักเรียน",
    address: "ที่อยู่",
    parents: "ข้อมูลผู้ปกครอง",
    other: "ข้อมูลอื่น ๆ"
  },
  download: "ดาว์นโหลด",
  downloadError: "ดาว์นโหลด ผิดพลาด",
  applicantReport: {
    title: "บัญชีรายชื่อผู้สมัคร",
    exam_authorize_title: "บัญชีรายชื่อผู้มีสิทธิ์สอบคัดเลือกนักเรียน",
    pass_authorize_title: "บัญชีรายชื่อผู้ผ่านการคัดเลือกนักเรียน",
    printDate: "วันที่พิมพ์",
    applicationName: "ชื่อรอบการสมัคร",
    page: "หน้า",
    totalPages: "จากทั้งหมด",
    tableHeader: {
      indexNo: "ลำดับที่",
      applicationID:'เลขประจำตัวผู้สมัคร',
      fullName:'ชื่อ-นามสกุล',
      curriculum:'แผนการเรียน',
      remark:'หมายเหตุ',
    },
  },
  remarkFillDash: "หมายเหตุ : หากไม่มีการกรอกข้อมูล ให้ใส่ - แทน",
  remarkFillShort: "หมายเหตุ : ยศหรือตำแหน่งให้ระบุเป็นตัวย่อ",
}

export const commonEN = {
  academic_year: "Academic year",
  grade:'Grade level',
  add: "Add",
  announcement_date: "Announcement date",
  back: "Back",
  cancel: "Cancel",
  candidate_amount: 'Applicants',
  confirm: "Confirm",
  create_at: "Create at",
  create_date: "Create date",
  curriculum: "Curriculum",
  currency: {
    baht: "THB"
  },
  data_not_found: "Data not found",
  date: "Date",
  document: "Document",
  documents: "Documents",
  grade_level: "Grade",
  last_edited: "Last edited",
  pagination: {
    of: "From",
    row_per_page: "Row per page"
  },
  required_amount: "Required amount",
  search: "Search",
  status: "Status",
  sidebar: {
    application_form: "Application form",
    set_up_application_form: "Set up application form",
    list_of_applicants: "List of applicants",
    list_of_qualified_applicants: "List of qualified applicants",
  },
  time: "Time",
  top_menu: {
    other_system: "Other system",
    schoolbus_system: "Schoolbus system",
    application_form: "Application form",
    tuition_payment: "Tuition payment",
  },
  logout: "Log out",
  id_card_number: "ID card number",
  full_name: "Fullname",
  type: "Type",
  suggestion: "Suggestion",
  previous: "Previous",
  next: "Next",
  page: "Page",
  close: "Close",
  person: "Person",
  applicantInfo: "Applicants information",
  edit:{
    basic: "Personal information",
    address: "Address",
    parents: "Parent information",
    other: "Other information"
  },
  download: "download",
  downloadError: "Error download",
  applicantReport: {
    title: "List of applicants",
    exam_authorize_title: "List of exam authorize",
    pass_authorize_title: "List of qualified",
    printDate: "Print Date",
    applicationName: "Application name",
    page: "Page",
    totalPages: "of",
    tableHeader: {
      indexNo: "No.",
      applicationID:'applicationID',
      fullName:'Fullname',
      curriculum:'Curriculum',
      remark:'Remark',
    },
  },
  remarkFillDash: "Remark : If there is no data, please fill in - instead",
  remarkFillShort: "Remark : Prefix please fill abbreviations",
}
